import { render, staticRenderFns } from "./FileFormatSelector.vue?vue&type=template&id=cd8fba5a&"
import script from "./FileFormatSelector.vue?vue&type=script&lang=ts&"
export * from "./FileFormatSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports